import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { mailLogicStateIsMerge, getTreeStatesByAccount, folderIdIsContact, folderIdIsAllTopFolder, folderIdIsAllFolderSubAccount, parseAccountFromAllFolderSubAccount, } from '@web-mail/util';
import { getIn18Text, inWindow, api, apis, isTest } from 'api';
import { KEEP_PERIOS, FLOLDER, MAIL_CROSS_ROOM_ERROR_TIP_LOCAL_KEY } from '@web-mail/common/constant';
import { useAppSelector, useAppDispatch, MailActions } from '@web-common/state/createStore';
import AutoReplyTips from './AutoReplyTips';
import PaidGuideTip from '@web-mail/components/PaidGuideModal/paidGuideTip';
import UnfinishedDraftMailEntry from '@web-mail/components/MailColumnEntry/unfinishedDraftMailEntry/unfinishedDraftMailEntry';
import CloudMailSearchEntry from '@web-mail/components/MailColumnEntry/cloudMailSearchEntry/cloudMailSearchEntry';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
import MailNoticeNum from './MailNoticeNum';
import MailSearchDeleteTip from './MailSearchDeleteTip';
import useLocalStorage from '@/hooks/useLocalStorage';
const advertApi = api.requireLogicalApi(apis.advertApiImpl);
const mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
const aiAssistantApi = api.requireLogicalApi(apis.aiAssistant);
const loginApi = api.requireLogicalApi(apis.loginApiImpl);
import styles from './mailListTips.module.scss';
import useUserLocalStorageState from '@web-mail/hooks/useUserLocalStorageState';
import EdmReplyTip from './EdmReplyTip';
const trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
let updateAdTime = null;
const AD_SPACE_CODE = '20250613';
const CLOSE_SPAN_TIME = isTest ? 1000 * 60 * 3 : 1000 * 60 * 60 * 24 * 1;
const MIN_SHOW_SPAN_TIME = isTest ? 1000 * 60 * 3 : 1000 * 60 * 5;
const MAX_CLOSE_COUNT = isTest ? 3 : 5;
const DEFAULT_TIMEOUT_TS = isTest ? 1000 * 60 * 5 : 1000 * 60 * 60 * 24 * 1;
let lastViewAdTime = 0;
const MailListTips = (props) => {
    const customerTipsRef = useRef();
    const [showStarContactBuildingTip] = useState2RM('showStarContactBuildingTip');
    const [selectedKeys] = useState2RM('selectedKeys');
    const [mailSearching] = useState2RM('mailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const [showThreadBuildingTip] = useState2RM('showThreadBuildingTip');
    const [configMailLayout] = useState2RM('configMailLayout');
    const isLeftRight = useMemo(() => configMailLayout === '1', [configMailLayout]);
    const isMerge = useMemo(() => mailLogicStateIsMerge(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId, isSearching), [selectedKeys, isSearching]);
    const [mailTreeStateMap] = useState2RM('mailTreeStateMap');
    const [otherClusterNode] = useState2RM('otherClusterNode');
    const [mailDelBanSetting, setMailDelBanSetting] = useState(false);
    const logicshowStarContactBuildingTip = useMemo(() => {
        return showStarContactBuildingTip && folderIdIsContact(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) && !isSearching;
    }, [showStarContactBuildingTip, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, isSearching]);
    const [aiAssistantFolderTip, setAiAssistantFolderTip] = useLocalStorage('ai_assistant_folder_tip', false);
    const aiAssistSideBarVisiable = useAppSelector(state => state.mailReducer.aiAssistSideBarVisiable);
    const currentFolderUnReadCount = useAppSelector(state => state.mailReducer.currentFolderUnReadCount);
    const [currentAdvertInfo, setCurrentAdvertInfo] = useState(null);
    const dispatch = useAppDispatch();
    const fetchAdvertInfo = () => {
        return advertApi.getAdvertInfo(AD_SPACE_CODE).then(res => {
            if (!res) {
                setCurrentAdvertInfo(null);
            }
            else {
                setCurrentAdvertInfo(res);
            }
            return res;
        });
    };
    const resetAdvertInfoTime = () => {
        if (updateAdTime) {
            clearTimeout(updateAdTime);
            updateAdTime = null;
        }
    };
    useEffect(() => {
        if (process.env.BUILD_ISEDM || process.env.BUILD_ISWEB) {
            return;
        }
        fetchAdvertInfo();
        return () => {
            resetAdvertInfoTime();
        };
    }, []);
    useEffect(() => {
        resetAdvertInfoTime();
        let timeOutTs = DEFAULT_TIMEOUT_TS;
        if (currentAdvertInfo) {
            if (currentAdvertInfo && currentAdvertInfo.autoFetchIntervalSecond > 0) {
                timeOutTs = currentAdvertInfo.autoFetchIntervalSecond * 1000;
            }
        }
        updateAdTime = setTimeout(() => {
            fetchAdvertInfo();
        }, timeOutTs);
    }, [currentAdvertInfo]);
    const StarContactBuildingTip = useMemo(() => {
        return logicshowStarContactBuildingTip ? React.createElement("div", { className: "u-alert" }, getIn18Text('WANGLAIYOUJIANBUILDTIP')) : React.createElement(React.Fragment, null);
    }, [logicshowStarContactBuildingTip]);
    const ThreadMailBuildingTip = useMemo(() => {
        return isMerge && showThreadBuildingTip ? React.createElement("div", { className: "u-alert" }, getIn18Text('JUHEYOUJIANSHU')) : React.createElement(React.Fragment, null);
    }, [showThreadBuildingTip, isMerge]);
    const getKeepPeriodByFolderId = useCallback((folderId) => {
        var _a, _b;
        const treeMap = (_a = getTreeStatesByAccount(mailTreeStateMap, selectedKeys.accountId)) === null || _a === void 0 ? void 0 : _a.MailFolderTreeMap;
        if (treeMap) {
            const folderItem = treeMap[folderId + ''];
            const folderKeepPeriod = (_b = folderItem === null || folderItem === void 0 ? void 0 : folderItem.entry) === null || _b === void 0 ? void 0 : _b.keepPeriod;
            if (!folderKeepPeriod) {
                return KEEP_PERIOS;
            }
            return folderKeepPeriod;
        }
        return KEEP_PERIOS;
    }, [mailTreeStateMap, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId]);
    const AdFolderTip = useMemo(() => {
        return inWindow() && !isSearching && selectedKeys && selectedKeys.id == FLOLDER.ADVITISE && !mailDelBanSetting ? (React.createElement("div", { className: "u-alert" }, getIn18Text('GUANGGAOYOUJIANTIANHZDSCYKQZDLJ', { day: getKeepPeriodByFolderId(FLOLDER.ADVITISE) }))) : null;
    }, [isSearching, selectedKeys.id]);
    const SpamFolderTip = useMemo(() => {
        return !isSearching && selectedKeys && selectedKeys.id == FLOLDER.SPAM && !mailDelBanSetting ? (React.createElement("div", { className: "u-alert" }, getIn18Text('LAJIYOUJIANTIANHZDSC(YKQZDLJ)', { day: getKeepPeriodByFolderId(FLOLDER.SPAM) }))) : null;
    }, [isSearching, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id]);
    const DeleteFolderTip = useMemo(() => {
        return !isSearching && selectedKeys && selectedKeys.id == FLOLDER.DELETED && !mailDelBanSetting ? (React.createElement("div", { className: "u-alert" }, getIn18Text('YISHANCHUYOUJIANTHZDCDSC', { day: getKeepPeriodByFolderId(FLOLDER.DELETED) }))) : null;
    }, [isSearching, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id]);
    const MailSearchDeleteTipMemo = useMemo(() => {
        return React.createElement(MailSearchDeleteTip, null);
    }, []);
    const closeAiAssistantTip = () => {
        setAiAssistantFolderTip(true);
    };
    const openAiAssistant = () => {
        aiAssistantApi.sendNotification({ type: 'tipOpen', data: true });
        dispatch(MailActions.doUpdateAiAssistVisiable(true));
        setAiAssistantFolderTip(true);
    };
    const AdvertTips = useMemo(() => {
        if (!currentAdvertInfo || !advertApi.getShouldShowAdvert(currentAdvertInfo.id, MAX_CLOSE_COUNT, CLOSE_SPAN_TIME)) {
            return null;
        }
        if (currentAdvertInfo.trackViewUrl) {
            if (!(lastViewAdTime && new Date().getTime() - lastViewAdTime < MIN_SHOW_SPAN_TIME)) {
                lastViewAdTime = new Date().getTime();
                trackApi.track('mailList_advertView', {
                    url: currentAdvertInfo.trackViewUrl,
                    spaceCode: AD_SPACE_CODE,
                    advertId: currentAdvertInfo.id,
                    title: currentAdvertInfo.title,
                });
                advertApi.track({
                    type: 'VIEW',
                    trackUrl: currentAdvertInfo.trackViewUrl,
                });
            }
        }
        const hasClickContent = currentAdvertInfo.clickContent && currentAdvertInfo.clickContent.length > 0;
        const handleClicked = () => {
            loginApi.doOpenAdvertUrl(currentAdvertInfo.clickUrl);
            if (currentAdvertInfo.trackClickUrl) {
                advertApi.track({
                    type: 'CLICK',
                    trackUrl: currentAdvertInfo.trackClickUrl,
                });
                trackApi.track('mailList_advertClick', {
                    title: currentAdvertInfo.title,
                    spaceCode: AD_SPACE_CODE,
                    advertId: currentAdvertInfo.id,
                });
            }
        };
        const handleCloseClicked = () => {
            advertApi.closeAdvert(currentAdvertInfo.id);
            setCurrentAdvertInfo(null);
        };
        const clickContentEl = () => hasClickContent ? (React.createElement("span", { className: "adbtn", onClick: () => {
                handleClicked();
            } }, currentAdvertInfo.clickContent)) : null;
        const closeEl = () => (React.createElement("span", { className: "adbtn close", onClick: () => {
                handleCloseClicked();
            } }, getIn18Text('CLOSE_AUTOLAUNCH')));
        return (React.createElement("div", { className: `u-maillist-ad-alert${!isLeftRight ? ' long' : ''}` },
            React.createElement("span", { className: "adicon" }),
            React.createElement("span", { className: "adtxt" },
                React.createElement("span", null, currentAdvertInfo.title),
                isLeftRight ? (React.createElement("div", { className: "adBtnWrapper" },
                    clickContentEl(),
                    closeEl())) : null),
            !isLeftRight ? (React.createElement("div", { className: "adBtnWrapper" },
                clickContentEl(),
                closeEl())) : null,
            React.createElement("span", { className: "close", onClick: () => {
                    advertApi.closeAdvert(currentAdvertInfo.id);
                    setCurrentAdvertInfo(null);
                } })));
    }, [currentAdvertInfo, isLeftRight]);
    const AiAssistantFolderTipComp = useMemo(() => {
        const showShowAdvertTip = currentAdvertInfo && advertApi.getShouldShowAdvert(currentAdvertInfo.id, 3, CLOSE_SPAN_TIME) ? true : false;
        return !showShowAdvertTip && !aiAssistantFolderTip && !aiAssistSideBarVisiable && currentFolderUnReadCount > 0 ? (React.createElement("div", { className: "u-ai-assistant-alert" },
            React.createElement("span", { className: "txt" }, getIn18Text('WEIDUYOUJIANTAIDUO')),
            React.createElement("span", { className: "btn", onClick: openAiAssistant }, getIn18Text('LIJIZONGJIE')),
            React.createElement("span", { className: "close", onClick: closeAiAssistantTip }))) : null;
    }, [aiAssistantFolderTip, aiAssistSideBarVisiable, currentFolderUnReadCount, currentAdvertInfo]);
    const [storeFolderSortInfo, setStoreFolderSortInfo] = useUserLocalStorageState(MAIL_CROSS_ROOM_ERROR_TIP_LOCAL_KEY, 0);
    const AllFolderTopCrossAreaTip = useMemo(() => {
        const isShow = otherClusterNode.length > 0 && !isSearching;
        if (isShow && folderIdIsAllTopFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) && storeFolderSortInfo == 0) {
            const emailStr = otherClusterNode.map(item => item.agentEmail).join(',');
            return (React.createElement("div", { className: styles.mlTipAllCross },
                React.createElement("span", { className: styles.mlTipAllContent }, getIn18Text('YINSHEJIKUAYOUJFWQ，YXYJWFJHZQBSJXCK，XQQLXKF。', { emailStr })),
                React.createElement("span", { className: styles.mlTipAllClose, onClick: () => {
                        setStoreFolderSortInfo(otherClusterNode.length);
                    } }, "\u5173\u95ED")));
        }
        const isCurAccount = otherClusterNode.find(item => item.agentEmail == parseAccountFromAllFolderSubAccount(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) || item.id == parseAccountFromAllFolderSubAccount(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id));
        if (isShow && folderIdIsAllFolderSubAccount(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) && isCurAccount) {
            return React.createElement("div", { className: styles.mlTipAllCross }, getIn18Text('YINSHEJIKUAYOUJFWQ，CYXYJWFJHZQBSJXCK，XQQLXKF。'));
        }
        return React.createElement(React.Fragment, null);
    }, [otherClusterNode, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, storeFolderSortInfo, isSearching]);
    useEffect(() => {
        var _a, _b;
        if ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.DELETED || (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.SPAM) {
            mailConfApi.getAccountBanSetting(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId).then(res => {
                setMailDelBanSetting(!!res.ban_del_mail);
            });
        }
        if ((_a = customerTipsRef === null || customerTipsRef === void 0 ? void 0 : customerTipsRef.current) === null || _a === void 0 ? void 0 : _a.reset) {
            (_b = customerTipsRef === null || customerTipsRef === void 0 ? void 0 : customerTipsRef.current) === null || _b === void 0 ? void 0 : _b.reset();
        }
    }, [selectedKeys]);
    return (React.createElement(ErrorBoundary, { errorVisiable: false, ref: customerTipsRef, name: "mailList-tips-wrap" },
        React.createElement(AutoReplyTips, null),
        DeleteFolderTip,
        SpamFolderTip,
        AdFolderTip,
        ThreadMailBuildingTip,
        StarContactBuildingTip,
        React.createElement(CloudMailSearchEntry, null),
        React.createElement(UnfinishedDraftMailEntry, null),
        React.createElement(PaidGuideTip, null),
        React.createElement(MailNoticeNum, null),
        MailSearchDeleteTipMemo,
        AllFolderTopCrossAreaTip,
        React.createElement(EdmReplyTip, null),
        process.env.BUILD_ISLINGXI ? AdvertTips : null));
};
export default MailListTips;
